import AgilityRichText from "./AgilityRichText";

const MediaContentCardListing = (props) => {
  const {
    title,
    description,
    backgroundColor,
    columns = 4,
    cards = [],
    additionalCTA,
    jumpLinkID = ""
  } = props;

  return (
    <section className={`${backgroundColor == "tw-bg-white" ? "lg:tw-my-16 tw-my-8" : "lg:tw-p-25 tw-p-8"} ${backgroundColor}`} id={jumpLinkID}>
      <div className="tw-container">
        {title && (
          <h2 className="tw-font-roboto tw-text-3.5xl tw-font-bold tw-normal-case tw-mb-4">{title}</h2>
        )}
        {description && (
          <AgilityRichText
            html={description}
            className="tw-max-w-3xl lg:tw-mb-10"
          />
        )}
        
        <div className={`tw-grid tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-${columns} tw-gap-8 tw-mt-8`}>
          {cards.map(({fields}, index) => (
            <div key={index} className="tw-flex tw-flex-col">
              {fields.image?.url && (
                <img
                  src={fields.image.url}
                  alt={fields.image.label || ""}
                  className="tw-w-full tw-h-48 tw-object-cover"
                />
              )}
              <div className="tw-py-4 tw-flex-1">
                {fields.title && (
                  <h3 className="tw-font-helv tw-text-xl tw-font-bold tw-normal-case tw-mb-2">{fields.title}</h3>
                )}
                {fields.excerpt && (
                  <AgilityRichText
                    html={fields.excerpt}
                    className="tw-font-helv tw-mb-4"
                  />
                )}
                {fields.description && (
                  <AgilityRichText
                    html={fields.description}
                    className="tw-font-helv tw-mb-4"
                  />
                )}
                {fields.cta?.text && (
                  <a
                    href={fields.cta.href}
                    target={fields.cta.target}
                    className="!tw-text-primary-red !tw-underline tw-mt-auto"
                  >
                    {fields.cta.text}
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>
        {additionalCTA?.text && (
          <a
            href={additionalCTA.href}
            target={additionalCTA.target}
            className="tw-block tw-mx-auto tw-bg-black tw-py-2 tw-px-6 tw-w-fit lg:tw-mt-14 tw-mt-8"
          >
            <span className="tw-text-white">{additionalCTA.text}</span>
          </a>
        )}
      </div>
    </section>
  );
};

export default MediaContentCardListing;
